import React from "react";
import { AdminHabitatRestorationProjectType } from "@ecologi/shared";
import { ProjectVisualsType } from "./project-visuals";
import WildflowersIcon from "@ecologi/assets/icons/ProjectInsights/wildflowers.svg";
import SeagrassIcon from "@ecologi/assets/icons/ProjectInsights/seagrass.svg";
import PeatlandsIcon from "@ecologi/assets/icons/ProjectInsights/peatlands.svg";

const PATH = "/images/app/forest/habitat_restoration/pictograms/";

export const habitatRestorationVisuals: Record<
  AdminHabitatRestorationProjectType,
  ProjectVisualsType
> = {
  WILDFLOWERS: {
    icon: <WildflowersIcon />,
    pictogram: `${PATH}wildflowers.svg`,
  },
  SEAGRASS: {
    icon: <SeagrassIcon />,
    pictogram: `${PATH}seagrass.svg`,
  },
  PEATLANDS: {
    icon: <PeatlandsIcon />,
    pictogram: `${PATH}peatlands.svg`,
  },
};
